import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { financialService } from '../services/financial.service';

export function useFinancialDashboard() {
  return useQuery({
    queryKey: ['financial', 'dashboard'],
    queryFn: () => financialService.getDashboard(),
  });
}

export function useFinancialCharts(period?: string) {
  return useQuery({
    queryKey: ['financial', 'charts', period],
    queryFn: () => financialService.getCharts(period),
  });
}

export function useFinancialForecast() {
  return useQuery({
    queryKey: ['financial', 'forecast'],
    queryFn: () => financialService.getForecast(),
  });
}

export function useFinancialCustomers(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['financial', 'customers', params],
    queryFn: () => financialService.getCustomers(params),
  });
}

export function useFinancialCustomerDetail(id: string) {
  return useQuery({
    queryKey: ['financial', 'customer', id],
    queryFn: () => financialService.getCustomerDetail(id),
    enabled: !!id,
  });
}

export function useFinancialSyncStatus() {
  return useQuery({
    queryKey: ['financial', 'sync-status'],
    queryFn: () => financialService.getSyncStatus(),
    refetchInterval: 10000,
  });
}

export function useFinancialSync() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => financialService.triggerSync(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['financial'] });
    },
  });
}

export function useFinancialSettings() {
  return useQuery({
    queryKey: ['financial', 'settings'],
    queryFn: () => financialService.getSettings(),
  });
}

export function useUpdateFinancialSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: financialService.updateSettings,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['financial', 'settings'] });
    },
  });
}
